export default "__VITE_ASSET__CY3WSJDV__"